module.exports = __webpack_public_path__ + "media/images/puzzle/puzzle_4-f9497f5678acf5be763409dc3f99aa9d.png";